import React from 'react';
import classNames from 'classnames';

const RegisterIcon = ({ propsClassName, iconImage, ariaLabelText, noRole }) => {
  return (
    <img
      className={classNames({
        'registration-icon': true,
        [propsClassName]: propsClassName,
      })}
      src={iconImage}
      alt="registration-icon"
      tabIndex={0}
      role={noRole ? null : 'button'}
      aria-label={ariaLabelText}
    />
  );
};

export default RegisterIcon;
